import { cx } from '@utils/cx'
import { isProdMode, isTestMode } from '@utils/env'

function ResponsiveIndicator() {
  if (isProdMode || isTestMode) return null

  const className = cx(
    'absolute bottom-2 left-2 z-100 flex items-center justify-center text-sm',
    'size-6 rounded-full',
    'bg-green-500 before:content-["xs"] sm:text-white',
    'sm:bg-yellow-500 sm:text-black sm:before:content-["sm"]',
    'sm:text-black md:bg-orange-500 md:before:content-["md"]',
    'sm:text-white lg:bg-red-500 lg:before:content-["lg"]',
    'sm:text-white xl:bg-blue-500 xl:before:content-["xl"]',
    'sm:text-white 2xl:bg-purple-500 2xl:before:content-["2xl"]'
  )

  return <div className={className} />
}

export default ResponsiveIndicator